<template>
  <div class="el-col-24">
    <!-- 标题 -->
    <h5 class="warp-title">机器人分类设置</h5>
    <!-- 筛选 -->
    <el-form :model="searchForm" :inline="true" class="search" size="small">
      <el-form-item label="平台">
        <el-select v-model="searchForm.platformId" placeholder="请选择分类平台">
          <el-option label="全部" value=""></el-option>
          <el-option :label="item.name" :value="item.id" v-for="(item, index) in specialPlatformList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="search-button" v-if="buttonPermission.robot_sort_query === 1" @click="getProblemType" :loading="isSearchLoading">查询</el-button>
        <el-button  type="primary" @click="addSort" v-if="buttonPermission.robot_sort_add === 1"> 新增分类</el-button>
      </el-form-item>
    </el-form>
    <!-- 分类内容 -->
    <div class="sort-content">
      <p class="title">说客英语分类</p>
      <el-table :data="tableData" border class="el-table" style="margin-top: 30px">
        <el-table-column prop="type" label="分类" width="300"></el-table-column>
        <el-table-column prop="platformName" label="平台" width="300"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-link :underline="false" type="primary" @click="editSort(scope.row.id)" v-if="buttonPermission.robot_sort_edit === 1">编辑</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页器 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      class="mt20"
      align="right"
      background>
    </el-pagination>
    <!-- 新增/编辑分类 -->
    <el-dialog :visible.sync="dialogVisible" width="25%" class="add-dialog" :show-close="false" :close-on-click-modal="false">
      <div slot="title" class="title">
        <h2 class="warp-title">{{dialogTitle}}</h2>
      </div>
      <div class="add-content">
        <el-form :model="addForm" :rules="addFormRules" ref="addForm">
          <el-form-item label="选择新增分类平台" prop="platformId">
            <el-radio-group v-model="addForm.platformId" class="platform-radio-container">
              <el-radio v-for="(item, index) in specialPlatformList" :key="index" :label="item.id">{{ item.name }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="type">
            <el-input v-model="addForm.type" placeholder="请输入分类名称" :maxlength="50"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="toSubmit" :loading="isAddLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryButtonPermission, getProblemType, returnProblemType, editProblemType, addProblemType } from '../../api/robotSort/index.js'
export default {
  name: 'RobotSort',
  created () {
    this.getButtonPermission()
    // this.getProblemType()
  },
  watch: {
    // 当新增/编辑框关闭时 清空校验
    dialogVisible (newVal) {
      if (!newVal) {
        this.$refs['addForm'].resetFields()
      }
    }
  },
  computed: {
    specialPlatformList () {
      return this.$store.state.Auth.specialPlatformList
    }
  },
  data () {
    return {
      isAddLoading: false,
      isSearchLoading: false,
      radio: 3,
      dialogVisible: false,
      dialogTitle: '新增分类',
      // 按钮权限
      buttonPermission: {},
      total: 10,
      tableData: [
      ],
      searchForm: {
        platformId: '',
        type: '',
        currentPage: 1,
        pageSize: 10
      },
      addForm: {
        platformId: '',
        type: ''
      },
      addFormRules: {
        platformId: [
          {required: true, message: '请选择分类平台', trigger: 'blur'}
        ],
        type: [
          {required: true, message: '请输入分类名称', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    // 新增分类
    addSort () {
      this.dialogTitle = '新增分类'
      this.addForm = {
        platformId: 0,
        type: ''
      }
      this.dialogVisible = true
    },
    // 编辑分类
    editSort (id) {
      this.dialogTitle = '编辑分类'
      this.dialogVisible = true
      this.addForm.id = id
      // 回显机器人分类
      returnProblemType({id}).then(res => {
        this.addForm = res.data.resultData
        console.log(this.addForm)
      })
    },
    // 页容量改变时
    handleSizeChange (size) {
      this.searchForm.pageSize = size
      this.searchForm.currentPage = 1
      this.getProblemType()
    },
    // 页码改变时
    handleCurrentChange (page) {
      this.searchForm.currentPage = page
      this.getProblemType()
    },
    // 获取按钮权限
    getButtonPermission () {
      queryButtonPermission({id: global.$sider}).then(res => {
        this.buttonPermission = res.data.resultData
      })
    },
    // 获取机器人分类列表
    getProblemType () {
      this.isSearchLoading = true
      getProblemType(this.searchForm).then(res => {
        this.isSearchLoading = false
        this.tableData = res.data.resultData
        this.total = res.data.totalCount
      }).catch(() => {
        this.isSearchLoading = false
      })
    },
    // 编辑/新增提交
    toSubmit () {
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          this.isAddLoading = true
          if (this.dialogTitle === '编辑分类') {
            // 编辑
            editProblemType(this.addForm).then(res => {
              this.isAddLoading = false
              this.$message({
                message: '编辑成功！',
                type: 'success'
              })
              this.dialogVisible = false
              this.searchForm.currentPage = 1
              this.getProblemType()
            }).catch(() => {
              this.isAddLoading = false
            })
          } else if (this.dialogTitle === '新增分类') {
            // 新增
            addProblemType(this.addForm).then(res => {
              this.isAddLoading = false
              this.$message({
                message: '新增成功！',
                type: 'success'
              })
              this.dialogVisible = false
              this.searchForm = {
                platformId: '',
                type: '',
                currentPage: 1,
                pageSize: 10
              }
              this.getProblemType()
            }).catch(() => {
              this.isAddLoading = false
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.search .search-button{
  margin-left: 30px;
}
.sort-content {
  margin-top: 30px;
}
.sort-content .title{
  font-size: 18px;
  font-weight: 700;
}
.add-dialog {
  .warp-title{
    margin: 0;
    margin-bottom: 20px;
  }
  /deep/ .el-dialog{
    padding: 20px;
  }
}
.add-dialog .title {
  // text-align: center;
}
/deep/ .el-dialog__body{
  padding: 0;
}
/deep/ .el-dialog__header{
  padding: 0;
}
/deep/tr.el-table__row td{
  text-align: center;
}
/deep/thead.has-gutter tr th{
  text-align: center;
}
/deep/.platform-radio-container {
  .el-radio{
    line-height: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RobotSort/Index.vue